// extracted by mini-css-extract-plugin
export default {"heading":"_1ABGI4PgZXcDKIvAqxW3vZ","text":"_3fOxenoN9jT-ZdGNWZQQpC"};